export default {
  init() {
    // JavaScript to be fired on all pages

    $('.gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      infinite: false,
    });

    $('.testimonials-awesome .notable-clients').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000,
    });

    $('.testimonials-awesome .normal-testimonials .testimonials').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000,
    });

    $('.hamburger').click(function(){
      $(this).toggleClass('open');
      $('.mobile-menu').toggleClass('open');

      if($(this).hasClass('open')){
        $('body').css('overflow', 'hidden');
      }else{
        $('body').css('overflow', 'auto');
      }
    });

    $('.menu-item-has-children').each(function(){
      $(this).append('<div class="arrow"></div>');
    });

    $('.menu-item-has-children .arrow').click(function(){
      $(this).toggleClass('open');
      $(this).closest('.menu-item-has-children').toggleClass('open');

      $('.menu-item-has-children.open').each(function(){
        $(this).closest('.menu-item-has-children').addClass('open');
      });
    });

    function initIncrements(){
      $('.quantity .increment-quantity').click(function(){
        $(this).siblings('[type="number"]').val( function(i, oldval) {
          return parseInt( oldval, 10) + 1;
        });

        $(this).closest('.quantity').siblings('button').prop('disabled', false);
      });

      $('.quantity .decrement-quantity').click(function(){
        $(this).siblings('[type="number"]').val( function(i, oldval) {
          if(oldval > 1) {
            return parseInt( oldval, 10) - 1;
          }else{
            return 0;
          }
        });

        $(this).closest('.quantity').siblings('button').prop('disabled', false);
      });
    }
    initIncrements();

    $(document).on('updated_cart_totals', function(){
              console.log('update_cart_totals');

      initIncrements();
    });

    $('#bottleCapacity').slider({
      range: true,
      min: 0,
      max: 1000,
      values: [ 250, 800 ],
      slide: function(event, ui) {
        $('#bottleCapacity').siblings('.min').html(ui.values[0]);
        $('#bottleCapacity').siblings('.max').html(ui.values[1]);
      },
    });

    $('#budget').slider({
      range: true,
      min: 0,
      max: 50000,
      values: [ 10000, 35000 ],
      slide: function(event, ui) {
        $('#budget').siblings('.min').html('$'+ui.values[0]);
        $('#budget').siblings('.max').html('$'+ui.values[1]);
      },
    });
    

    $('#category-best-options').click(function(e){
      var bottleMin = $('#bottleCapacity').slider('values', 0);
      var bottleMax = $('#bottleCapacity').slider('values', 1);
      var budgetMin = $('#budget').slider('values', 0)
      var budgetMax = $('#budget').slider('values', 1)

      e.preventDefault();
      location.href = $('#category-select').val() + '?min_price=' + budgetMin + '&max_price=' + budgetMax + '&capacity_min=' + bottleMin + '&capacity_max=' + bottleMax;
    });

    //create custom checkbox
    $('.frm_checkbox label').append('<div class="custom-checkbox"></div>');

    //collapse product category filters
    $('.product-categories .cat-parent').each(function(){
      $(this).append('<div class="arrow-toggle"></div>');
      $(this).children('.children').hide();

      refreshFilters();
    });

    function refreshFilters(){
      $('.current-cat-parent').each(function(){
        $(this).children('.children').show();
        $(this).children('.arrow-toggle').addClass('open');
      });
  
      $('.current-cat').children('.children').show();
      $('.current-cat').children('.arrow-toggle').addClass('open');
    }
    refreshFilters();

    $('.product-categories .arrow-toggle').click(function(){
      $(this).toggleClass('open');
      $(this).siblings('.children').slideToggle();
    });
    
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js